import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import AddressSchemaFormManuallyUK from '../../../AddressAutocompleteSearch/UK/AddressSchemaFormManuallyUK';
import AddressAutofillFormUK from '../../../AddressAutocompleteSearch/UK/AddressAutofillFormUK';

const addressFieldsForReset = {
  postalCode: '',
  addressLine1: '',
  addressLine2: '',
  locality: '',
  administrativeArea: {},
};

// TODO: change it to pure component.
class AddressSchemaFormUK extends React.Component {
  constructor(props) {
    super(props);

    this.changeSchemaType = this.changeSchemaType.bind(this);
  }

  /**
   * Switcher between AutofillUK form and ManuallyUK form
   */
  changeSchemaType = (schemaType, autoSwitched) => {
    const { setFormValue, setAddressValues } = this.props;

    setFormValue('addressSchemaType', { type: schemaType, autoSwitched });

    // Reset address fields in case when user clicked on the "Search again" button.
    if (!autoSwitched && schemaType === 'default') {
      setAddressValues(addressFieldsForReset);
    }
  };

  render() {
    const {
      addressSchemaType = { type: 'default', autoSwitched: false },
      setAddressValues,
      addressLine1 = '',
      postalCode = '',
    } = this.props;

    // We need to render Manually UK form in following cases:
    // - When addressLine1 and postcode were auto-populated by Autofill Uk form
    // - When user switched to Manual UK form by click on the button
    const renderManualUKForm =
      addressSchemaType.type === 'manually' || (addressLine1 && postalCode);

    return renderManualUKForm ? (
      <AddressSchemaFormManuallyUK
        changeSchemaType={() => this.changeSchemaType('default', false)}
        autoSwitched={addressSchemaType.autoSwitched}
      />
    ) : (
      <AddressAutofillFormUK
        postalCode={postalCode}
        addressLine1={addressLine1}
        changeSchemaType={this.changeSchemaType}
        setAddressValues={setAddressValues}
      />
    );
  }
}

AddressSchemaFormUK.propTypes = {
  addressSchemaType: PropTypes.shape({
    type: PropTypes.string,
    autoSwitched: PropTypes.bool,
  }),
  setFormValue: PropTypes.func.isRequired,
  setAddressValues: PropTypes.func.isRequired,
  postalCode: PropTypes.oneOfType([PropTypes.shape, PropTypes.string]),
  addressLine1: PropTypes.oneOfType([PropTypes.shape, PropTypes.string]),
};

const mapStateToProps = ({
  donationForm: {
    form: { values },
  },
}) => ({
  addressSchemaType: values.addressSchemaType ?? { type: 'default', autoSwitched: false },
  postalCode: values.address ? values.address.postalCode : '',
  addressLine1: values.address ? values.address.addressLine1 : '',
});

export default connect(mapStateToProps)(AddressSchemaFormUK);
